import React from 'react';
import SpaceBetween from '@amzn/awsui-components-console/space-between';
import ColumnLayout from '@amzn/awsui-components-console/column-layout';
import './ApplicationDetailCardSkeleton.scss';

const ApplicationDetailCardSkeleton: React.FC = () => {
  return (
    <div className="application-detail-card-skeleton">
      <SpaceBetween size="l">
        <div className="application-detail-card-skeleton__header">
          <div className="application-detail-card-skeleton__title-section">
            <div className="application-detail-card-skeleton__title skeleton-shimmer" />
            <div className="application-detail-card-skeleton__subtitle skeleton-shimmer" />
          </div>
          <div className="application-detail-card-skeleton__button skeleton-shimmer" />
        </div>

        <div className="application-detail-card-skeleton__metadata">
          <ColumnLayout columns={3} variant="text-grid">
            <div className="application-detail-card-skeleton__key-value">
              <div className="application-detail-card-skeleton__key skeleton-shimmer" />
              <div className="application-detail-card-skeleton__value skeleton-shimmer" />
            </div>
            <div className="application-detail-card-skeleton__key-value">
              <div className="application-detail-card-skeleton__key skeleton-shimmer" />
              <div className="application-detail-card-skeleton__value skeleton-shimmer" />
            </div>
            <div className="application-detail-card-skeleton__key-value">
              <div className="application-detail-card-skeleton__key skeleton-shimmer" />
              <div className="application-detail-card-skeleton__value skeleton-shimmer" />
            </div>
          </ColumnLayout>
        </div>

        <div className="application-detail-card-skeleton__subscriptions">
          <div className="application-detail-card-skeleton__subscriptions-label skeleton-shimmer" />
          <div className="application-detail-card-skeleton__data-sources">
            <div className="application-detail-card-skeleton__data-source skeleton-shimmer" />
            <div className="application-detail-card-skeleton__data-source skeleton-shimmer" />
            <div className="application-detail-card-skeleton__data-source skeleton-shimmer" />
          </div>
        </div>
      </SpaceBetween>
    </div>
  );
};

export default ApplicationDetailCardSkeleton;
